const toCount = (value) => {
  const count = Number(value);
  return Number.isFinite(count) ? count : 0;
};

const byPosition = (field) => (left, right) =>
  toCount(left?.[field]) - toCount(right?.[field]);

const withoutStrikethrough = (className) =>
  String(className ?? "")
    .split(/\s+/)
    .filter(
      (cssClass) =>
        cssClass && cssClass !== "qub-css-font-strikethrough"
    )
    .join(" ");

const normalizeStatus = (status = {}) => ({
  ...status,
  count: toCount(status.count),
  statusPosition: toCount(status.statusPosition),
  statusCssClass: withoutStrikethrough(status.statusCssClass),
});

const normalizeType = (type = {}) => ({
  ...type,
  totalCount: toCount(type.totalCount),
  activeCount: toCount(type.activeCount),
  typePosition: toCount(type.typePosition),
  statuses: Array.isArray(type.statuses)
    ? type.statuses
        .map(normalizeStatus)
        .sort(byPosition("statusPosition"))
    : [],
});

const normalizeCategory = (category = {}) => ({
  ...category,
  position: toCount(category.position),
  types: Array.isArray(category.types)
    ? category.types.map(normalizeType).sort(byPosition("typePosition"))
    : [],
  summary: Array.isArray(category.summary)
    ? category.summary
        .map(normalizeStatus)
        .sort(byPosition("statusPosition"))
    : [],
});

const normalizeMarker = (apartment = {}) => {
  const lat = Number(apartment?.position?.lat);
  const lng = Number(apartment?.position?.lng);

  if (
    apartment?.position?.lat == null ||
    apartment?.position?.lng == null ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng) ||
    lat < -90 ||
    lat > 90 ||
    lng < -180 ||
    lng > 180
  ) {
    return null;
  }

  return {
    ...apartment,
    id: apartment.id ?? apartment.appartmentId,
    title:
      apartment.title ||
      `Διαμέρισμα${apartment.appartmentPosition ? ` ${apartment.appartmentPosition}` : ""}`,
    position: { lat, lng },
  };
};

export const normalizeApartmentsMapData = (payload = {}) => ({
  totalApartments: toCount(payload?.totalApartments),
  apartmentsWithCoordinates: toCount(
    payload?.apartmentsWithCoordinates
  ),
  apartments: Array.isArray(payload?.apartments)
    ? payload.apartments.map(normalizeMarker).filter(Boolean)
    : [],
});

export const normalizeDashboardData = (payload = {}) => ({
  lastUpdatedAt: payload.lastUpdatedAt ?? null,
  lastUpdatedAtFormatted: payload.lastUpdatedAtFormatted ?? "",
  categories: Array.isArray(payload.categories)
    ? payload.categories
        .map(normalizeCategory)
        .sort(byPosition("position"))
    : [],
  map: normalizeApartmentsMapData(payload.map),
});
